import { AfterViewInit, DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, debounceTime, fromEvent } from 'rxjs';

import { UserStore } from '@signal-store';

@Directive({
  selector: '[appendColor]',
})
export class AppendColorDirective implements AfterViewInit {
  private userStore = inject(UserStore);
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private destroyRef = inject(DestroyRef);
  theme$ = toObservable(this.userStore.theme.color).pipe(takeUntilDestroyed());
  themeMode$ = toObservable(this.userStore.theme.mode).pipe(takeUntilDestroyed());
  ngAfterViewInit() {
    const element = this.el.nativeElement as HTMLInputElement;
    const { color } = this.userStore.theme();
    let themeElementRef = document.querySelector<HTMLElement>(`body.${color}-theme`);

    combineLatest([this.theme$, this.themeMode$])
      .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(1))
      .subscribe(([theme]) => {
        // Appearance modes share the body's light palette, including Dark and Browser.
        themeElementRef = document.querySelector(`body.${theme}-theme`);
        const computedStyles = getComputedStyle(themeElementRef);
        element.value = computedStyles.getPropertyValue(`--${element.id}`);
      });

    fromEvent(element, 'input')
      .pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef))
      .subscribe(event => {
        const color = (event.target as HTMLInputElement).value;
        navigator.clipboard.writeText(color);
        themeElementRef.style.setProperty(`--${element.id}`, color);
      });
  }
}
